import React from "react";
import loaderGIF from "@frameworks/web/assets/images/Reports/loaderGIF.gif";
const Loader = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `b-overlay position-absolute outerdivloader ${props.className ? props.className : ""} ` },
            React.createElement("div", { className: `position-absolute middleloader ${props.noBackGround ? "" : "bg-light"}` }),
            React.createElement("div", { className: "position-absolute innerloader" },
                React.createElement("img", { src: loaderGIF })))));
};
export default Loader;
